import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { __ } from "../../utils";
import { useStores } from "../../store";
import { useLocation } from "react-router-dom";
const NoticeServiceDataProcessingInUnsafeCountries = observer(()=>{
    const { optionStore } = useStores();
    const { pathname } = useLocation();
    const { servicesDataProcessingInUnsafeCountriesNoticeHtml } = optionStore;
    return servicesDataProcessingInUnsafeCountriesNoticeHtml && pathname.indexOf("/edit/") === -1 && pathname.indexOf("/new") === -1 && /*#__PURE__*/ _jsxs("div", {
        className: "notice notice-warning inline below-h2 notice-alt",
        style: {
            margin: "10px 0 0 0"
        },
        children: [
            /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: servicesDataProcessingInUnsafeCountriesNoticeHtml
                }
            }),
            " ",
            /*#__PURE__*/ _jsxs("p", {
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        href: "#/settings/consent",
                        children: __("Enable consent to data processing in unsafe third countries")
                    }),
                    " ",
                    "•",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        onClick: ()=>optionStore.dismissServiceDataProcessingInUnsafeCountriesNotice(),
                        children: __("Dismiss notice")
                    })
                ]
            })
        ]
    });
});
export { NoticeServiceDataProcessingInUnsafeCountries };
